// TelcoTrack - Topbar page title bridge
// Invisible directive for pages that do not use app-page-header.

import {
  Directive,
  Input,
  OnChanges,
  DestroyRef,
  inject,
} from '@angular/core';
import { TopbarPageTitleService } from '../../core/services/topbar-page-title.service';
import type { NavIconId } from '../utils/nav-icons';

@Directive({
  selector: '[ttTopbarPageTitle]',
})
export class TopbarPageTitleDirective implements OnChanges {
  private readonly ownerId = Symbol('topbar-page-title');
  private readonly topbarTitle = inject(TopbarPageTitleService);
  private readonly destroyRef = inject(DestroyRef);

  /** Page title — bound via `[ttTopbarPageTitle]="'Polygony'"` or a dynamic expression. */
  @Input('ttTopbarPageTitle') title = '';
  /** Optional topbar subtitle under the title — `[ttTopbarPageTitleSubtitle]="'Dashboard polygonu'"`. */
  @Input() ttTopbarPageTitleSubtitle = '';
  /** Optional sidebar-matching icon — `[ttTopbarPageTitleIcon]="'maps'"`. */
  @Input() ttTopbarPageTitleIcon: NavIconId | '' = '';

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.topbarTitle.clearTitle(this.ownerId);
    });
  }

  ngOnChanges(): void {
    this.topbarTitle.setTitle(
      this.ownerId,
      this.title,
      this.ttTopbarPageTitleIcon,
      this.ttTopbarPageTitleSubtitle,
    );
  }
}
